module.exports = __webpack_public_path__ + "img/hilfe_handschrift_01.f0ed77a9.png";